export const DEFAULT_STATE = {
    data: null,
    metadata: null,
    csvdata: null,
    grandTotal: 0,
    isGtLoading: false,
    isLoading: false,
};
